import React from "react";

import MDInput from "materialDashboard/components/MDInput";
import Autocomplete from "@mui/material/Autocomplete";
import {useTranslation} from "react-i18next";


const Model1StatusAutocomplete = ({ setModel1Statuses, ...props }) => {
    const {t} = useTranslation("inputs");

    const statusOptions = ["OPEN", "CLOSED", "CONFIRMED"]; // TODO: save the enum in a config file or fetch from the backend
    const statusLabels = statusOptions.reduce((acc, s ) => {
        acc[s] = t(`enums:model1Status.${s}`);
        return acc;
    }, {})

    return <Autocomplete
        id="model1-status-autocomplete"
        options={statusOptions}
        getOptionLabel={(status) => statusLabels[status]}
        filterOptions={(x) => x}
        onChange={(e, value) => setModel1Statuses(value)}
        renderInput={(params) => (
            <MDInput {...params}
                     variant="standard"
                     label={t('model1StatusAutocomplete.label')}
                     placeholder={t('model1StatusAutocomplete.placeholder')}
            />
        )}
        multiple
        {...props}
    />
}

export default Model1StatusAutocomplete;